import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgGlovo = function SvgGlovo(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_g || (_g = /*#__PURE__*/_jsx("g", {
      clipPath: "url(#glovo_svg__a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-.48-.48h35.96v35.96H-.48V-.48Zm20.696 15.277a2.02 2.02 0 0 0 .116-.43v-.004.004a2.833 2.833 0 1 0-5.665 0v-.004.004c.003.022.02.158.117.43.112.312.294.702.553 1.16.521.923 1.241 1.928 1.982 2.862a.295.295 0 0 0 .103.09.182.182 0 0 0 .156 0 .295.295 0 0 0 .103-.09c.74-.934 1.46-1.94 1.982-2.861.259-.459.44-.849.553-1.16Zm-.17 5.897c1.578-1.991 3.305-4.571 3.305-6.327a5.851 5.851 0 0 0-11.702 0c0 1.756 1.727 4.336 3.304 6.327a3.219 3.219 0 0 0 5.094 0Zm-2.546 5.79a1.855 1.855 0 1 0 0-3.71 1.855 1.855 0 0 0 0 3.71Z",
        fill: "currentColor"
      })
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "glovo_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h35v35H0z"
        })
      })
    }))]
  }));
};
export default SvgGlovo;